import { useEffect } from "react";

const SITE_ORIGIN = "https://magicznakeratyna.pl";

/**
 * Dynamically updates <link rel="canonical"> for SPA route changes.
 *
 * The initial canonical is set synchronously in main.tsx (before React mounts)
 * so Googlebot's first DOM read on the rendered page shows the correct URL.
 * This hook keeps it in sync as the user navigates client-side.
 *
 * @param path - URL path starting with "/" (e.g. "/blog", "/blog/my-post")
 */
export const useCanonical = (path: string) => {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    // Also keep og:url in sync for social shares.
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", url);
    // No cleanup that restores previous value — the next route's hook (or
    // main.tsx for full reloads) is the single source of truth.
  }, [path]);
};
